// Document preview inside a design's A4 placeholder = RimoPreview's inline box (components/preview, the suite's one
// preview): pages scroll inside, „‹ 1 / 3 ›“ and the big view (double click). Here only RimoCompta's right-click menu
// is added. The signed URL is fetched once (RimoPreview's cache) and never stored. With `documentId` (the primary PDF of an
// incoming invoice) its notes lie over the pages and „Drucken“ / „Herunterladen“ deliver them (useDocLayer, ES correction);
// „Original herunterladen“ is the unchanged file, only on purpose.
import { useRef, useState } from 'react';
import { RimoPreview, RimoPreviewInline, previewKind, rimoPreviewActions } from '@rimocore/shared/preview/RimoPreview';
import { useContextMenu } from '@rimocore/shared/ctx/registry';
import { tr2 } from '../i18n/lang';
import { shortcut } from '@rimocore/shared/ctx/menu';
import { useDocLayer } from './layers/useDocLayer';

/** `page` (1-based) shows only that page (import: one page at a time); the big view still has all pages. */
export function DocPreview({ url, mimeType, page, title, documentId }: { url: string; mimeType: string; page?: number; title?: string; documentId?: string | null }) {
  const root = useRef<HTMLDivElement>(null), [full, setFull] = useState(false);
  const name = title || 'Dokument', kind = previewKind(mimeType, name);
  const L = useDocLayer(kind === 'pdf' ? documentId : null, true);
  // Right-click (components/ctx): big view, download, print – the same actions as RimoPreview's bar.
  useContextMenu(root, () => [
    kind !== 'other' && { label: tr2('Große Ansicht', 'Grand aperçu'), icon: 'expand', run: () => setFull(true) },
    { label: tr2('Herunterladen', 'Télécharger'), icon: 'download', run: () => (L.layer?.download ? L.layer.download() : rimoPreviewActions.download(url, name, mimeType)) },
    kind !== 'other' && { label: tr2('Drucken', 'Imprimer'), icon: 'print', hint: shortcut('P'), run: () => (L.layer?.print ? L.layer.print() : rimoPreviewActions.print(url, name, mimeType)) },
    L.has && { label: tr2('Original herunterladen', 'Télécharger l’original'), icon: 'download', run: () => rimoPreviewActions.download(url, name, mimeType) },
  ]);
  return (
    <div ref={root} style={{ width: '100%', height: '100%' }}>
      <RimoPreviewInline source={url} fileName={name} mimeType={mimeType} page={page} overlay={L.overlay} layer={L.layer} />
      {full && <RimoPreview source={url} fileName={name} mimeType={mimeType} startPage={page} overlay={L.overlay} layer={L.layer} onClose={() => setFull(false)} />}
    </div>
  );
}
